/**
 * Preferences JS
 */
export const Lists = (function () {


    var lists = {

        /** Uses the PDS function to get the preferences */
        buildEvents : function () {
            var dataset_name = 'ds_profiles_preferences'
            var preferences_name = 'hobbies_interests'

            var dataset = PDS.pds.get(dataset_name);
            var preferences = dataset.then((response) => {
                return Preferences.preferences.extractTags(preferences_name,response);
            });
            var tags = preferences.then((response) => {
                return MRD.listings.getEvents(response);
            });
            /** Finally, build the preferences from the response  */
            tags.then((response) => {
                                
                Lists.lists.buildAll(response);

            });
        },
        displayEmpty : function(){
            var div = document.getElementById('future_events_list');
            var header = document.createElement('h2');
            header.setAttribute('class', 'text-secondary text-center');
            header.innerHTML = "There are no events based of your current <a class='text-white' href='/hobbies-interests'>preferences</a>";
            div.appendChild(header);
        },

        buildAll : function(events){
            if(events.length > 0){

                for (const event of events) {
                    
                    Lists.lists.build(event);
                    
                 } 
            }else{
                    Lists.lists.displayEmpty();
            }
        },
        checkFuture : function(timestamp){
            var timeNow = Math.round((new Date()).getTime() / 1000);
            return (timestamp < timeNow);
        },

        build : function(event_item){

            /**
             * Check the event is a future event
             * We treat past an future events differently
             */
            var isFutureEvent = this.checkFuture(event_item.event_end_date);
            var div_name = (isFutureEvent) ? 'future_events_list' : 'past_events_list';
            var div = document.getElementById(div_name);

            var c = document.createElement('div');
            c.setAttribute('class', 'card border-primary mb-3 text-light');

            var body = document.createElement('div');
            body.setAttribute('class', 'card-body');
            body.setAttribute('style', 'cursor: -webkit-grab; cursor: pointer;')
            body.setAttribute('onclick', "Util.openInNewTab('"+event_item.event_url+"')");


            var container = document.createElement('div');
            container.setAttribute('class', 'container');

            body.appendChild(container);

            var row = document.createElement('div');
            row.setAttribute('class', 'row flex-nowrap');

            container.appendChild(row);

            var col1 = document.createElement('div');
            col1.setAttribute('class', 'pr-4');


            var img = document.createElement('img');
            img.setAttribute('class', 'image_class primary');
            img.setAttribute('src', '/static/images/icons/noun_tickets_711469.svg');
            img.setAttribute('style', 'object-fit: scale-down; max-height: 50px; max-width: 50px;');

            col1.appendChild(img);

            var col2 = document.createElement('div');
            col2.setAttribute('class', 'col-xs-2');
            col2.innerHTML = '<span></span>';

            var col3 = document.createElement('div');
            col3.setAttribute('class', 'col-xs-6');
            col3.innerHTML = Util.convertDate(event_item.event_from_date) + '  ' + event_item.event_start_time.slice(0,-3);

            row.appendChild(col1);
            row.appendChild(col2);
            row.appendChild(col3);

            /**
             * We add a Past Event pill if the `isFutureEvent` is true
             */
            if(!isFutureEvent){
                var col4 = document.createElement('div');
                var span = document.createElement('span');
                span.innerHTML = "Past Event ";
                col4.setAttribute('class', 'col-xs-8');;
                span.setAttribute('class', 'badge badge-pill badge-secondary m-2');;
                col3.appendChild(span);
                row.appendChild(col4);
            }

            var p = document.createElement('p');
            p.setAttribute('class', 'card-text font-weight-bold');
            p.innerHTML = event_item.event_name;

            col3.appendChild(p);

            c.appendChild(body);

            div.appendChild(c);

        }

        
    }

    return {
        lists:lists
    }

}());
